export const componentMap = new Map([
  ['shopHeader', () => import('@/components/canvasShow/slwshop/home/shopHeader')], // 首页头部
  ['text', () => import('@/components/canvasShow/basics/text')], // 文本
  ['imageText', () => import('@/components/canvasShow/basics/imageText')], // 图文
  ['brandList', () => import('@/components/canvasShow/basics/brandList')], // 品牌列表
  ['categoryList', () => import('@/components/canvasShow/basics/categoryList')], // 品牌列表
  ['imageTextList', () => import('@/components/canvasShow/basics/imageTextList')], // 图文列表
  ['productList', () => import('@/components/canvasShow/basics/productList')], // 商品列表
  ['videoBox', () => import('@/components/canvasShow/basics/video')], // 视频
  ['coupon', () => import('@/components/canvasShow/basics/coupon')], // 优惠券
  ['custom', () => import('@/components/canvasShow/basics/custom')] // 优惠券
])
export default componentMap



// WEBPACK FOOTER //
// ./src/components/canvasShow/componentMap.js